module.exports = __webpack_public_path__ + "static/img/newanli-06.b9d77374.png";